import { getStringPropFromObjectOrNull } from '../../utils/stringUtils'

export class TextSettingsHelper {
  _settings

  constructor(settings) {
    this._settings = settings
  }

  get descriptionRaw() {
    return getStringPropFromObjectOrNull(this._settings, 'description')
  }

  get descriptionStyle() {
    return (this._settings && this._settings.description_style) || null
  }

  get title() {
    return getStringPropFromObjectOrNull(this._settings, 'title')
  }

  get titleStyle() {
    return (this._settings && this._settings.title_style) || null
  }
}
